
export const FinancingRequestedMessage = 'Financement demandé';
export const FinancingRequestRejectedMessage = `Demande de financement non-acceptée`
export const REQUEST_FINANCING_ACTION_TEXT = 'Financer';
